import { ICategoria } from '../interface/ICategoria';
import { Producto } from './Producto';

export class Categoria implements ICategoria {

  id?: number;
  nombre?: string;
  imagen?: string;
  descripcion?: string;
  visibleEn?: string[];
  esFantasia: boolean;
  publicada: number;
  categoriaId?: number;
  orden: number;
  ordenFantasia?: number;
  posicionGaleria: number;
  categoriasHijas?: Categoria[];
  porductos?: Producto[];
  fecCreacion?: Date;
  fecModificacion?: Date;

  hijasFantasia?: Categoria[];
  bannerMenu?: any;
  modificado?: boolean;
  nuevaImagen?: any;
  nuevoOrden?: any;
  accion?: string;
  categoria?: Categoria;

  constructor(categoria: ICategoria) {
    this.id = categoria.id;
    this.nombre = categoria.nombre;
    this.imagen = categoria.imagen;
    this.descripcion = categoria.descripcion;
    this.visibleEn = categoria.visibleEn;
    this.esFantasia = categoria.esFantasia;
    this.publicada = categoria.publicada;
    this.categoriaId = categoria.categoriaId;
    this.orden = categoria.orden;
    this.ordenFantasia = categoria.ordenFantasia;
    this.posicionGaleria = categoria.posicionGaleria;
    this.categoriasHijas = categoria.categoriasHijas;
    this.porductos = categoria.porductos;
    this.fecCreacion = categoria.fecCreacion;
    this.fecModificacion = categoria.fecModificacion;
    this.modificado = categoria.modificado;
    this.nuevaImagen = categoria.nuevaImagen;
    this.hijasFantasia = categoria.hijasFantasia;
    this.bannerMenu = categoria.bannerMenu;
    this.nuevoOrden = categoria.orden;
    this.categoria = categoria.categoria;
  }

  getEstado(): string {
    if (this.publicada === 1) {
      return 'Publicada';
    } else {
      return 'No Publicada';
    }
  }

  getVisibleEnStr(): string {
    let visibleStr = '';
    if (this.visibleEn) {
      for (let i = 0; this.visibleEn.length > i; i++) {
        visibleStr = visibleStr + '"' + this.visibleEn[i] + '"';
        if (i < (this.visibleEn.length - 1)) {
          visibleStr = visibleStr + ',';
        }
      }
    }
    return visibleStr;
  }

  getFormDataVisibleEn(): FormData {
    const formData = new FormData();
    if (typeof this.orden !== 'undefined') {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }

    if (typeof this.visibleEn !== 'undefined') {
      formData.append('visibleEn', this.getVisibleEnStr());
    } else {
      formData.append('visibleEn', '');
    }
    return formData;
  }

  getFormDataNuevoOrden(): FormData {
    const formData = new FormData();
    if (typeof this.nuevoOrden !== 'undefined') {
      this.orden = this.nuevoOrden;
      formData.append('orden', String(this.nuevoOrden));
    } else {
      formData.append('orden', '0');
    }
    return formData;
  }

  getFormData(): FormData {
    const formData = new FormData();

    if (this.nombre) {
      formData.append('nombre', this.nombre);
    }
    if (this.descripcion) {
      formData.append('descripcion', this.descripcion);
    }
    if (this.descripcion) {
      formData.append('descripcion', this.descripcion);
    }
    if (this.visibleEn) {
      formData.append('visibleEn', this.getVisibleEnStr());
    }
    if (this.esFantasia && this.esFantasia === true) {
      formData.append('esFantasia', '1');
    } else {
      formData.append('esFantasia', '0');
    }
    if (this.publicada) {
      formData.append('publicada', '1');
    } else {
      formData.append('publicada', '0');
    }
    if (this.categoriaId) {
      formData.append('categoriaId', String(this.categoriaId));
    }
    if (this.orden) {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }
    if (this.ordenFantasia) {
      formData.append('ordenFantasia', String(this.ordenFantasia));
    } else {
      formData.append('ordenFantasia', '0');
    }
    if (this.posicionGaleria) {
      formData.append('posicionGaleria', String(this.posicionGaleria));
    } else {
      formData.append('posicionGaleria', '0');
    }
    if (this.nuevaImagen) {
      formData.append('file_upload', this.nuevaImagen, this.nuevaImagen.name);
    }


    return formData;
  }




}



// WEBPACK FOOTER //
// /app/src/model/class/Categoria.ts